import { useContext } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { ConfigContext } from '../context/configContext'

export const useGetPartnerId = () => {
  const { id } = useParams()
  const { partnerData } = useContext(ConfigContext)
  return id ?? partnerData.id
}
